import React from "react"
import { Icon, IconButton } from "native-base"
import { Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";
import { IDisposer, onPatch } from "mobx-state-tree";
import { useFocusEffect } from "@react-navigation/native";
import { ITEM_STATUS } from "../../../voolks/types";
import { isElementArchived, openPDF, _findField, checkIsValid } from "../../../utils/itemCommonFunctions";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import { ButtonIcon,Button ,Text} from "@gluestack-ui/themed";
import { Platform } from "react-native";
import NetInfo, { NetInfoStateType } from '@react-native-community/netinfo';
import { ActionButton } from "../../../components";

export const GetActionButtonsFC = ({ statusStore, itemsStore,formsStore, navigation, setShouldHide, pageActive, form, saveAndGo, forReview,ItemsListScreenName, withTitles }) => {
  const [isValidItem, setIsValidItem] = React.useState<boolean>(false);
  const [isConnected, setIsConnected] = React.useState<boolean | null>(null);
  console.log("ItemDetailsScreen", "GetActionButtonsFc", "isValidItem", isValidItem, "pageActive", pageActive); 
  const validateItem = () => {
    console.log("ItemDetailsScreen", "validateItem", "isValidItem", isValidItem, "pageActive", pageActive, "forReview", forReview, "form.pages.length", form.pages.length); 
    if (forReview == false && form.pages.length == (pageActive + 1)) {
      console.log("GetActionButtonsFC", "validateItem",statusStore.loadingFieldIdGet());
      const isvalid: boolean = checkIsValid(itemsStore, form) && statusStore.loadingFieldIdGet().length==0;
      isValidItem != isvalid && setIsValidItem(isvalid);
      return isvalid;
    }
    return false;
  }
  const validateItemDebounced = useDebouncedCallback(validateItem, 500);
  useFocusEffect(() => {
    setShouldHide(false);
    validateItem();
    if (forReview != true) {
      let _disposerOnPatch: IDisposer
      _disposerOnPatch = onPatch(itemsStore, patch => {
        validateItemDebounced();
      })
      return () => {
        setShouldHide(true)
        _disposerOnPatch();
      }
    }
    return undefined;
  });
  React.useEffect(() => {

    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected && state.type == NetInfoStateType.wifi);
    });

    return () => {
      unsubscribe(); // Limpiar la suscripción
    };
  }, [])

  const itemStatus = itemsStore.itemActive.status;
  const upload = async () => {
      if (itemStatus == ITEM_STATUS.draft)
        await itemsStore.saveItemActive(ITEM_STATUS.closed);      
      await itemsStore.upload({ itemIDX: itemsStore.itemActiveIDX });
      saveAndGo();
      if(form.type=="workflow" || form.type=="ptw")
        await formsStore.syncFlows(form.type==="ptw");
      
  }

  const notValid = async (event)=>{
    let retName: string[] = [];
    checkIsValid(itemsStore, form,undefined,retName)
    if(statusStore.loadingFieldIdGet().length>0)
        retName.push("Procesando datos...")
    const hint = retName.join(", ")
    statusStore.setHintMessage("Campos inválidos:", hint, undefined, undefined);
    validateItem();
  }

  const uploadDebounced = useDebouncedCallback(upload, 500);

  if (itemStatus == ITEM_STATUS.draft) {
    if (pageActive != (form.pages.length - 1))
      return <Button width={50} height={50} px="$2" variant="solid" isDisabled={true} key="actionButton-checkHidden" onPress={() => {}}>
      <ButtonIcon as={Ionicons} name="checkmark" color="$primary400"  size="xl"/>                 
    </Button>;
    if (forReview == false)
      return <ActionButton 
        key="actionButton-saveToPreview"
        withTitles={withTitles} 
        isValidItem={isValidItem} 
        iconName="checkmark" 
        iconFamily={Ionicons} 
        title="Revisar" 
        onPress={(event: any) => {if(validateItem()) saveAndGo({ goTo: "ItemDetails", forReview: true }); else notValid(event);}} 
      />;
    if (forReview == true && (Platform.OS == "web" || isConnected))
      return <><ActionButton 
        key="actionButton-uploadItem"
        withTitles={withTitles} 
        isValidItem={true} 
        iconName="cloud-upload" 
        iconFamily={MaterialCommunityIcons} 
        title="Subir" 
        onPress={uploadDebounced} 
      /><ActionButton 
        key="actionButton-closeItem"
        withTitles={withTitles} 
        isValidItem={true} 
        iconName="lock-closed" 
        iconFamily={Ionicons} 
        title="Cerrar" 
        onPress={() => saveAndGo({ goTo: ItemsListScreenName, itemStatus: ITEM_STATUS.closed, forReview: true })} 
      /></>;
    if (forReview == true)
      return <ActionButton 
        key="actionButton-closeItem"
        withTitles={withTitles} 
        isValidItem={true} 
        iconName="lock-closed" 
        iconFamily={Ionicons} 
        title="Cerrar" 
        onPress={() => saveAndGo({ goTo: ItemsListScreenName, itemStatus: ITEM_STATUS.closed, forReview: true })} 
      />;
  }

  if (itemStatus == ITEM_STATUS.closed) {
    return <><ActionButton 
      key="actionButton-openItem"
      withTitles={withTitles} 
      isValidItem={true} 
      iconName="lock-open" 
      iconFamily={Ionicons} 
      title="Abrir" 
      isDisabled={itemsStore.itemActive.readOnly == true}
      onPress={() => saveAndGo({ goTo: "ItemDetails", itemStatus: ITEM_STATUS.draft, forReview: false })} 
    /><ActionButton 
      key="actionButton-uploadItem"
      withTitles={withTitles} 
      isValidItem={true} 
      iconName="cloud-upload" 
      iconFamily={MaterialCommunityIcons} 
      title="Subir" 
      onPress={uploadDebounced} 
    /></>;
  }

  if (itemStatus == ITEM_STATUS.sent) {
    return <><ActionButton 
      key="actionButton-emailPDF"
      withTitles={withTitles} 
      isValidItem={true} 
      iconName="mail" 
      iconFamily={Ionicons} 
      title="Email" 
      onPress={() => openPDF(itemsStore, itemsStore.itemActive, true)} 
    /><ActionButton 
      key="actionButton-openPDF"
      withTitles={withTitles} 
      isValidItem={true} 
      iconName="file-pdf" 
      iconFamily={FontAwesome5} 
      title="PDF" 
      onPress={() => openPDF(itemsStore, itemsStore.itemActive)} 
    /></>;
  }
  return <></>;
};